import React, { FC, useState, useEffect } from 'react';

import { Button, Card, CardContent, Grid, TextField, Typography } from '@mui/material';

import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';

import axios from '../../../sharedModules/utils/axios.utils';

const UNKNOWN_CONTACT_SX = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(211, 47, 47, 0.1)',
  },
} as const;

interface ContactInfoUpdatingFieldsProps {
  contactId: string;
  firstName: string;
  lastName: string;
  fetchBackflowJobGroup: () => void;
}

const ContactInfoUpdatingFields: FC<ContactInfoUpdatingFieldsProps> = (props) => {
  const { contactId, firstName, lastName, fetchBackflowJobGroup } = props;

  const [firstNameValue, setFirstNameValue] = useState<string>(firstName || '');
  const [lastNameValue, setLastNameValue] = useState<string>(lastName || '');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setFirstNameValue(firstName || '');
    setLastNameValue(lastName || '');
  }, [firstName, lastName]);

  const handleUpdate = async () => {
    setLoading(true);
    try {
      await axios.put(`/sales_estimates/contacts/${contactId}`, {
        contact: { first_name: firstNameValue, last_name: lastNameValue },
      });
      setErrorMessage('');
      fetchBackflowJobGroup();
    } catch (error) {
      setErrorMessage('Something went wrong updating the contact');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card elevation={3}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ErrorMessage message={errorMessage} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Primary Contact First Name"
              value={firstNameValue}
              onChange={(e) => setFirstNameValue(e.target.value)}
              variant="outlined"
              size="small"
              disabled={loading}
              sx={firstNameValue === 'UNKNOWN' ? UNKNOWN_CONTACT_SX : undefined}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Primary Contact Last Name"
              value={lastNameValue}
              onChange={(e) => setLastNameValue(e.target.value)}
              variant="outlined"
              size="small"
              disabled={loading}
              sx={lastNameValue === 'UNKNOWN' ? UNKNOWN_CONTACT_SX : undefined}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">
              Updating values here does not affect data in Servman.
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="left">
            <Button variant="contained" style={{ marginTop: 15 }} onClick={handleUpdate}>
              Update
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ContactInfoUpdatingFields;
